module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-50.6ded02c2.jpg";